<template>
  <div v-loading="loading">
    <div class="title">题目校对</div>
    <div class="mb-12">
      <el-input
        class="w-200 mr-12"
        size="small"
        clearable
        placeholder="任务名称"
        v-model="name"
      >
      </el-input>
      <el-button type="primary" size="small" plain @click="handleSearch"
        >查询</el-button
      >
      <el-button size="small" @click="handleClearSearch">重置</el-button>
    </div>
    <el-table :data="taskList" :stripe="true">
      <el-table-column width="80" label="编号" prop="id"></el-table-column>
      <el-table-column min-width="135" label="任务名称">
        <template slot-scope="scope">
          <div
            class="hidden-redundant"
            @click="openDialog(scope.row.description)"
          >
            <el-link type="primary" :underline="false">{{
              scope.row.name
            }}</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="110"
        label="题目数量"
        prop="questions_count"
      ></el-table-column>
      <el-table-column
        width="65"
        label="待校对"
        prop="questions_waiting_count"
      ></el-table-column>
      <el-table-column
        width="65"
        label="已校对"
        prop="questions_verified_count"
      ></el-table-column>
      <el-table-column
        width="65"
        label="已拒绝"
        prop="questions_rejected_count"
      ></el-table-column>
      <el-table-column
        width="65"
        label="已通过"
        prop="questions_passed_count"
      ></el-table-column>
      <el-table-column
        width="80"
        label="语言"
        prop="langs_label"
      ></el-table-column>
      <el-table-column width="100">
        <template slot="header">
          <div @click="toggleShowContent" class="toggle-show">
            <span>价格</span>
            <i class="el-icon-view toggle-show-icon"></i>
          </div>
        </template>
        <template slot-scope="scope">
          <show-hide-content
            :value="scope.row.total_price"
            :show.sync="isShow"
          ></show-hide-content>
        </template>
      </el-table-column>
      <el-table-column
        width="80"
        label="状态"
        prop="status_label"
      ></el-table-column>
      <el-table-column
        width="130"
        label="任务截止时间"
        prop="end_at"
      ></el-table-column>
      <el-table-column width="130" label="完成时间">
        <template slot-scope="scope">
          {{ scope.row.finished_at || "-" }}
        </template>
      </el-table-column>
      <el-table-column width="100" label="操作" fixed="right">
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="goDetail(scope.row.id)"
            >进入任务</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="goPage"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :hide-on-single-page="true"
    >
    </el-pagination>

    <el-dialog
      class="skill-task-dialog"
      :visible.sync="dialogVisible"
      width="1000px"
      :show-close="false"
      center
    >
      <markdown-it :md="dialogDescription"></markdown-it>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import MarkdownIt from "@jiker/markdown-it/MarkdownIt.vue";
import skillService from "@/global/service/skill";
import ShowHideContent from "@/components/ShowHideContent";

export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      dialogDescription: "",
      name: null,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      isShow: false,
      taskList: []
    };
  },
  components: {
    MarkdownIt,
    ShowHideContent
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  created() {
    this.getData();
  },
  watch: {
    $route() {
      this.getData();
    }
  },
  methods: {
    getData() {
      const page = Number(this.$route.query.page) || 1;
      const params = {
        page,
        page_size: this.pagination.pageSize,
        name: this.name
      };
      this.loading = true;
      skillService
        .proofreadTasksMy(params)
        .then(res => {
          this.taskList = res.list;
          this.pagination.currentPage = Number(res.pagination.current_page);
          this.pagination.total = Number(res.pagination.total);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goPage(val) {
      this.$router.push({
        name: "QuestionProofreadMySelf",
        query: { page: val }
      });
    },
    goDetail(id) {
      this.$router.push({
        name: "QuestionProofreadMyDetail",
        params: { id }
      });
    },
    toggleShowContent() {
      this.isShow = !this.isShow;
    },
    openDialog(description) {
      this.dialogVisible = true;
      this.dialogDescription = description;
    },
    handleSearch() {
      this.pagination.currentPage = 1;
      this.getData();
    },
    handleClearSearch() {
      this.name = null;
      this.pagination.currentPage = 1;
      this.getData();
    }
  }
};
</script>
<style lang="less" scoped>
.toggle-show {
  cursor: pointer;
  .toggle-show-icon {
    margin-left: 4px;
  }
  &:hover {
    color: #409eff;
  }
}
</style>
